// 📁 components/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../UserContext";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useUser();

  if (loading) {
  return <div className="text-center mt-10 text-[#105132]">Loading...</div>;
}

  return user && user.token ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
